/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Evidenceinlinewithoutsuggestion3Inputs */

const en_evidenceinlinewithoutsuggestion3 = /** @type {(inputs: Evidenceinlinewithoutsuggestion3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strengthen this with a supporting document →`)
};

const pt_evidenceinlinewithoutsuggestion3 = /** @type {(inputs: Evidenceinlinewithoutsuggestion3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reforçar com um documento de suporte →`)
};

/**
* | output |
* | --- |
* | "Strengthen this with a supporting document →" |
*
* @param {Evidenceinlinewithoutsuggestion3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const evidenceinlinewithoutsuggestion3 = /** @type {((inputs?: Evidenceinlinewithoutsuggestion3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Evidenceinlinewithoutsuggestion3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_evidenceinlinewithoutsuggestion3(inputs)
	return pt_evidenceinlinewithoutsuggestion3(inputs)
});
export { evidenceinlinewithoutsuggestion3 as "evidenceInlineWithoutSuggestion" }